import type { ReactNode } from 'react';
import { css } from 'styled-system/css';

export function Cell({
  children,
  align,
  commented,
  selected,
  proposal,
}: {
  children?: ReactNode;
  align?: 'right';
  commented?: boolean;
  selected?: boolean;
  proposal?: boolean;
}) {
  return (
    <span
      data-commented={commented || undefined}
      data-selected={selected || undefined}
      data-proposal={proposal || undefined}
      className={css({
        position: 'relative',
        paddingInline: '3',
        paddingBlock: '2',
        borderLeft: '1px solid token(colors.border.hairline)',
        textAlign: align,
        '&:last-child': {
          borderRight: '1px solid token(colors.border.hairline)',
        },
        fontVariantNumeric: 'tabular-nums',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        '&[data-commented]::after': {
          content: '""',
          position: 'absolute',
          top: '0',
          right: '0',
          borderTop: '6px solid token(colors.prism.violet)',
          borderLeft: '6px solid transparent',
        },
        '&[data-selected]': {
          zIndex: 1,
          color: 'text.primary',
          background: 'bg.subtle',
          outline: '2px solid token(colors.border.focus)',
          outlineOffset: '-2px',
        },
        '&[data-proposal]': {
          zIndex: 1,
          color: 'text.primary',
          backgroundImage:
            'linear-gradient(90deg, color-mix(in srgb, token(colors.prism.violet) 25%, transparent), color-mix(in srgb, token(colors.prism.mid) 25%, transparent), color-mix(in srgb, token(colors.prism.green) 25%, transparent))',
        },
        '&[data-proposal]::before': {
          content: '""',
          position: 'absolute',
          inset: '0',
          zIndex: 1,
          pointerEvents: 'none',
          border: '1px solid transparent',
          background:
            'linear-gradient(90deg, token(colors.prism.violet), token(colors.prism.mid), token(colors.prism.green)) border-box',
          mask: 'linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0)',
          maskComposite: 'exclude',
          WebkitMask:
            'linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0)',
          WebkitMaskComposite: 'xor',
        },
      })}
    >
      {children}
    </span>
  );
}
